import React, { useState, useEffect } from 'react';
import { getUsers } from '../services/pocketbase';
import './AdminUsers.css';

function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        setLoading(true);
        try {
            const data = await getUsers();
            setUsers(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const filteredUsers = users.filter(user =>
        (user.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.email || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="loader">Chargement des utilisateurs...</div>;

    return (
        <div className="admin-users">
            <div className="admin-header">
                <h2>👥 Gestion des Utilisateurs</h2>
                <div className="search-box">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="Rechercher un utilisateur..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="users-table-container">
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>Avatar</th>
                            <th>Nom</th>
                            <th>Email</th>
                            <th>Rôle</th>
                            <th>Date d'inscription</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.length === 0 ? (
                            <tr><td colSpan="5" className="no-result">Aucun utilisateur trouvé</td></tr>
                        ) : (
                            filteredUsers.map(user => (
                                <tr key={user.id}>
                                    <td>
                                        <div className="user-avatar-small">
                                            {user.avatar ? (
                                                <img
                                                    src={`${process.env.REACT_APP_POCKETBASE_URL || 'https://studioambre.infocolab.online'}/api/files/users/${user.id}/${user.avatar}`}
                                                    alt={user.name}
                                                />
                                            ) : (
                                                <div className="avatar-placeholder">{user.name ? user.name[0].toUpperCase() : 'U'}</div>
                                            )}
                                        </div>
                                    </td>
                                    <td>{user.name || 'Sans Nom'}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        <span className={`role-badge ${user.role === 'admin' ? 'role-admin' : 'role-user'}`}>
                                            {user.role === 'admin' ? 'Administrateur' : 'Client'}
                                        </span>
                                    </td>
                                    <td>{new Date(user.created).toLocaleDateString()}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AdminUsers;
